var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "lang_de-a",
    cx: 36,
    cy: 36,
    r: 36
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lang_de-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lang_de-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    xlinkHref: "#lang_de-a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 24,
    fill: "#181A1A",
    mask: "url(#lang_de-b)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 24,
    y: 24,
    fill: "#D00",
    mask: "url(#lang_de-b)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 24,
    y: 48,
    fill: "#FFCE00",
    mask: "url(#lang_de-b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    stroke: "#000",
    strokeOpacity: 0.2,
    mask: "url(#lang_de-b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangDe);
export default __webpack_public_path__ + "static/media/lang-de.31ee8bd66ea191793d6d35afd4f7d2af.svg";
export { ForwardRef as ReactComponent };